import {
  AppBar,
  Box,
  Button,
  debounce,
  Dialog,
  Divider,
  Grid,
  ListItem,
  ListItemIcon,
  ListItemText,
  Skeleton,
  TextField,
  Toolbar,
  Typography,
} from "@mui/material";
import { useEffect, useRef, useState } from "react";
import { useAppSelector } from "../../../../hooks/store-hooks";
import {
  useProjetosService,
  useRecortesExtracaoService,
} from "../../../../../use-cases/geo-veles";
import { useNavigate, useParams } from "react-router-dom";
import { filterKeysToLabel, onlyNumbers } from "../../../../../utils";
import { theme } from "../../../../styles";
import LabelImportantIcon from "@mui/icons-material/LabelImportant";
import { IFiltrosProjeto, ITipoUsuario } from "../../../../../application/models";
import DownloadIcon from "@mui/icons-material/Download";
import { Card, CardContent, CardHeader } from "@mui/material";

export const ExtracaoPadrao = () => {
  // State
  const {
    projetoAberto,
    createExtracaoForm,
    filtrosSelecionados,
    relatorioProjeto,
  } = useAppSelector((state) => state.projetos);
  const travaConsumo = useAppSelector((state) => state.travaConsumo);
  // Use State
  const [loading, setLoading] = useState<boolean>(true);
  const { currentUser, access } = useAppSelector((state) => state.user);
  const auth = useAppSelector((state) => state.auth);
  const { recorteExtracao } = useAppSelector((state) => state.recorteExtracao);
  // Use Ref
  const isFirstRender = useRef(false);
  // Use Params
  const { id } = useParams();
  // Hook
  const {
    resetCreateExtracaoForm,
    setCreateExtracaoFormNome,
    setCreateExtracaoFormQuantidade,
    createExtracao,
    verifyTravaConsumo,
    setVerifyAcesso,
    resetRelatorioProjeto,
  } = useProjetosService();

  const { resetRecorteExtracao } = useRecortesExtracaoService();
  const navigate = useNavigate();
  // Function
  const closeDialog = () => {
    navigate(`/geo-veles/projetos/${id}`);
    resetRelatorioProjeto();
    resetCreateExtracaoForm();
  };
  const debouncedNome = debounce(
    (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
      setCreateExtracaoFormNome(e.target.value);

    },
    500
  );
  useEffect(() => {
    if (recorteExtracao) {
      resetRecorteExtracao();
    }
  }, [resetRecorteExtracao]);

  const userIdLocalStorage = Number(localStorage.getItem("userId")) || 0;
  const idClienteLocalStorage = Number(localStorage.getItem("idCliente")) || 0;

  useEffect(() => {
    setLoading(false);
  }, []);

  useEffect(() => {
    if (!isFirstRender.current) {
      setLoading(false);
      isFirstRender.current = true;
    }
  }, []);

  useEffect(() => {
    if (!projetoAberto) {
      navigate(`/geo-veles/projetos/${id}`);
    }
    else {
      setCreateExtracaoFormNome(projetoAberto.Nome);
    }
  }, [id, navigate, projetoAberto]);

  useEffect(() => {
    if (!access) {
      setVerifyAcesso();
    }
  });

  useEffect(() => {
  });

  useEffect(() => {
    verifyTravaConsumo({
      IdCliente: idClienteLocalStorage,
      IdUsuario: userIdLocalStorage,
    });
  }, [idClienteLocalStorage, userIdLocalStorage, verifyTravaConsumo])


  let quantidadeMaximaCliente: number = 0;
  let quantidadeMaximaUsuario: number = 0;
  let quantidadeMaxima: number =
    travaConsumo.data.quantidadeMaximaExtracaoPermitadaPorUsuarioExcetoVendedor;
  let labelTravaConsumoUsuario: string = "";
  let labelTravaConsumoUsuarioConsumiu: string = "";
  let labelTravaConsumoCliente: string = "";
  let labelTravaConsumoClienteConsumiu: string = "";

  if (travaConsumo.data.travaConsumo.UsuarioTravaQuantidade > 0) {
    quantidadeMaximaUsuario =
      travaConsumo.data.travaConsumo.UsuarioTravaQuantidade -
      travaConsumo.data.travaConsumo.UsuarioConsumiu;
    labelTravaConsumoUsuario = `Quantidade de registros permitidos para extração do usuário <strong>${currentUser?.LoginUsuario}</strong>: <strong>${quantidadeMaximaUsuario}</strong>`;
    labelTravaConsumoUsuarioConsumiu = `Quantidade de registros consumidos pelo usuário <strong>${currentUser?.LoginUsuario}</strong>: <strong>${travaConsumo.data.travaConsumo.UsuarioConsumiu}</strong>`;
  }

  // Verifica a trava de consumo do cliente
  if (travaConsumo.data.travaConsumo.ClienteTravaQuantidade > 0) {
    quantidadeMaximaCliente =
      travaConsumo.data.travaConsumo.ClienteTravaQuantidade -
      travaConsumo.data.travaConsumo.ClienteConsumiu;
    labelTravaConsumoCliente = `Quantidade de registros permitidos para extração do cliente <strong>${auth.loginForm.fields.loginCliente}</strong>: <strong>${quantidadeMaximaCliente}</strong>`;
    labelTravaConsumoClienteConsumiu = `Quantidade de registros consumidos pelo cliente <strong>${auth.loginForm.fields.loginCliente}</strong>: <strong>${travaConsumo.data.travaConsumo.ClienteConsumiu}</strong>`;
  }

  // Se o usuário e o cliente não tiverem trava, mantém a variável quantidadeMaximaCliente e quantidadeMaximaUsuario
  if (
    travaConsumo.data.travaConsumo.UsuarioTravaQuantidade === 0 &&
    travaConsumo.data.travaConsumo.ClienteTravaQuantidade === 0
  ) {
    quantidadeMaximaCliente = quantidadeMaxima;
    quantidadeMaximaUsuario = quantidadeMaxima;
  }

  return (
    <>
      {projetoAberto && (
        <Dialog
          open={true}
          onClose={closeDialog}
          fullScreen
          disableEscapeKeyDown
        >
          <AppBar sx={{ position: "relative" }}>
            <Toolbar>
              <Typography
                sx={{ ml: 2, flex: 1 }}
                textTransform={"uppercase"}
                variant="h6"
                component="div"
              >
                {loading ? (
                  <Skeleton animation="wave" variant="text" width={400} />
                ) : (
                  <>
                    Exportação padrão - Projeto{" "}
                    <strong>{projetoAberto.Nome}</strong>
                  </>
                )}
              </Typography>
              <Button
                color="inherit"
                onClick={closeDialog}
                aria-label="close"
                sx={{
                  fontWeight: "bold",
                }}
              >
                Fechar
              </Button>
            </Toolbar>
          </AppBar>
          <Box
            display="flex"
            flexDirection="column"
            justifyContent="center"
            alignItems="center"
            p={2}
          >
            <Grid
              container
              spacing={2}
              justifyContent="center"
              alignItems="center"
            >
              <Grid container item xs={12} alignItems="center" spacing={5}>
                <Grid item xs={6}>
                  <Grid item xs={12}>
                    <Typography
                      variant="h6"
                      color="primary"
                      fontWeight="bold"
                      textTransform="uppercase"
                      textAlign="center"
                    >
                      Nome
                    </Typography>
                  </Grid>
                  <Grid item xs={12}>
                    <TextField
                      // disabled
                      onChange={debouncedNome}
                      error={Boolean(
                        createExtracaoForm.touched &&
                        createExtracaoForm.errors.find(
                          (item) => item.key === "nome"
                        )
                      )}
                      helperText={
                        createExtracaoForm.errors.find(
                          (item) => item.key === "nome"
                        )?.message
                      }
                      name="nome"
                      fullWidth
                      id="nome"
                      label="Nome da Exportação"
                      defaultValue={
                        createExtracaoForm.fields.nome //+
                        // " - " +
                        // new Date().toLocaleDateString("pt-br")
                      }
                    />
                  </Grid>
                </Grid>
                <Grid item xs={6}>
                  <Grid item xs={12}>
                    <Typography
                      variant="h6"
                      color="primary"
                      fontWeight="bold"
                      textTransform="uppercase"
                      textAlign="center"
                    >
                      Quantidade
                    </Typography>
                  </Grid>

                  <Grid item xs={12}>
                    <TextField
                      value={createExtracaoForm.fields.quantidade.toLocaleString(
                        "pt-BR"
                      )}
                      onChange={(e) =>
                        setCreateExtracaoFormQuantidade(
                          onlyNumbers(e.target.value)
                        )
                      }
                      error={Boolean(
                        createExtracaoForm.touched &&
                        createExtracaoForm.errors.find(
                          (item: { key: string; }) => item.key === "quantidade"
                        )
                      )}
                      helperText={
                        createExtracaoForm.errors.find(
                          (item: { key: string; }) => item.key === "quantidade"
                        )?.message
                      }
                      name="quantidade"
                      fullWidth
                      id="quantidade"
                      label="Quantidade de registros que deseja exportar"
                    />
                  </Grid>
                </Grid>
                <Grid item xs={6}>
                  <Grid item xs={12}></Grid>

                  <Grid item xs={12}></Grid>
                </Grid>

                <Grid item xs={6}>
                  <Grid item xs={12}></Grid>

                  <Grid item xs={12}>
                    <Card
                      sx={{
                        marginBottom: 4,
                        marginTop: -2,
                        backgroundColor: "#f9f9f9",
                      }}
                    >
                      <CardHeader
                        align="center"
                        title="Informações"
                        fontWeight="bold"
                        titleTypographyProps={{
                          component: Typography, // Usa o seu componente Typography
                          color: "primary",
                          textTransform: "uppercase",
                          align: "center",
                          fontWeight: "bold",
                          variant: "h6",
                          // Outras propriedades do seu Typography
                        }}
                      />
                      <CardContent>
                        <Typography>
                          <span>
                            Quantidade registros para a extração do projeto :{" "}
                            <strong>
                              {relatorioProjeto?.dados.disponiveis.toLocaleString(
                                "pt-br"
                              )}
                            </strong>
                          </span>{" "}
                          <br />
                          <span>
                            Quantidade máxima de registros permitido(s) para
                            extração pela plataforma :{" "}
                            <strong>
                              {travaConsumo.data.quantidadeMaximaExtracaoPermitadaPorUsuarioExcetoVendedor.toLocaleString(
                                "pt-br"
                              )}{" "}
                            </strong>
                          </span>{" "}
                          <br />
                        </Typography>
                      </CardContent>
                    </Card>
                    <Card
                      hidden={
                        currentUser?.IdCliente === 1 ||
                        (travaConsumo.data.travaConsumo.ClienteTravaQuantidade ===
                          0 &&
                          travaConsumo.data.travaConsumo.UsuarioTravaQuantidade ===
                            0)
                      }
                      sx={{ backgroundColor: "#f9f9f9" }}
                    >
                      <CardHeader
                        align="center"
                        title="Trava de consumo"
                        fontWeight="bold"
                        titleTypographyProps={{
                          component: Typography, // Usa o seu componente Typography
                          color: "primary", // Cor do texto
                          textTransform: "uppercase", // Transforma o texto em maiúsculas
                          align: "center", // Alinha o texto ao centro
                          fontWeight: "bold",
                          variant: "h6",
                          // Outras propriedades do seu Typography
                        }}
                      />
                      <CardContent>
                        <Typography>
                          {/* Exibe a linha do vendedor se for o caso */}
                          {travaConsumo.data.travaConsumo.UsuarioTravaQuantidade >
                            0 && (
                            <>
                              <span
                                dangerouslySetInnerHTML={{
                                  __html: labelTravaConsumoUsuario, // Exibe a quantidade de registros que o usuário pode consumir
                                }}
                              ></span>
                              <br />
                              <span
                                dangerouslySetInnerHTML={{
                                  __html: labelTravaConsumoUsuarioConsumiu, // Exibe a quantidade que o usuário já consumiu
                                }}
                              ></span>
                              <br />
                            </>
                          )}

                          {/* Se o cliente tiver a trava de consumo, exibe as informações do cliente */}
                          {travaConsumo.data.travaConsumo.ClienteTravaQuantidade >
                            0 && (
                            <>
                              <span
                                dangerouslySetInnerHTML={{
                                  __html: labelTravaConsumoCliente, // Exibe a quantidade de registros que o cliente pode consumir
                                }}
                              ></span>
                              <br />
                              <span
                                dangerouslySetInnerHTML={{
                                  __html: labelTravaConsumoClienteConsumiu, // Exibe a quantidade que o cliente já consumiu
                                }}
                              ></span>
                              <br />
                            </>
                          )}

                          {/* Se o usuário for vendedor, exibe as informações do vendedor, mas apenas uma vez */}
                          {currentUser?.IdVelesPerfilInterno === ITipoUsuario.USUARIO_VELES_COMERCIAL &&
                            travaConsumo.data.travaConsumo
                              .UsuarioTravaQuantidade === 0 && (
                              <span
                                dangerouslySetInnerHTML={{
                                  __html: labelTravaConsumoUsuario, // Exibe a quantidade de registros que o vendedor pode consumir
                                }}
                              ></span>
                            )}
                        </Typography>
                      </CardContent>
                    </Card>
                  </Grid>
                </Grid>
              </Grid>
              <Grid item xs={12} mt={2}>
                <Typography
                  variant="h6"
                  color="primary"
                  fontWeight="bold"
                  textTransform="uppercase"
                  textAlign="center"
                >
                  Resumo dos filtros selecionados
                </Typography>
              </Grid>
              <Grid item xs={10}>
                <Divider variant="middle" color={theme.palette.primary.main} />
              </Grid>
              <Grid container spacing={2} m={2}>
                {/* Todos os filtros simples, incluindo listasCbo */}
                {Object.keys(filtrosSelecionados ?? {})
                  .filter(key => {
                    const value = (filtrosSelecionados as any)?.[key];
                    const label = filterKeysToLabel(key as keyof IFiltrosProjeto);
                    if (label === '') return false;

                    if (value === undefined) return false;
                    if (Array.isArray(value) && value.length === 0) return false;
                    return true;
                  })
                  .map((key, i) => (
                    <Grid item xs={4} key={i}>
                      <ListItem
                        sx={{
                          border: "1px solid #ddd",
                          borderRadius: "4px",
                          backgroundColor: "#f9f9f9",
                          padding: "8px",
                        }}
                      >
                        <ListItemIcon>
                          <LabelImportantIcon />
                        </ListItemIcon>
                        <ListItemText
                          primary={filterKeysToLabel(
                            key as keyof IFiltrosProjeto
                          )}
                        />
                      </ListItem>
                    </Grid>
                  ))}
              </Grid>
              <Grid item xs={10}>
                <Divider variant="middle" color={theme.palette.primary.main} />
              </Grid>
              <Grid item xs={6}>
                <Button
                  disabled={createExtracaoForm.fields.quantidade === 0}
                  variant="contained"
                  color="primary"
                  fullWidth
                  endIcon={<DownloadIcon />}
                  onClick={() => {
                    createExtracao();
                  }}
                >
                  Iniciar exportação
                </Button>
              </Grid>
            </Grid>
          </Box>
        </Dialog>
      )}
    </>
  );
};